import { GETSTAFF_SUCCESS, GET_SELF } from '../types';

const initialState = {
  staffData: [],
  self: null
};

export default function StaffReducer(state = initialState, action) {
  switch (action.type) {
    case GETSTAFF_SUCCESS:
      return {
        ...state,
        staffData: action.payload
      };
    case GET_SELF:
      return {
        ...state,
        self: action.payload
      };
    default:
      return state;
  }
}
